import { v4 as uuidv4 } from 'uuid'
import { clearTimeZone } from '../../../../../../helpers/date'
import { transformRightAllocationUnit } from '../../formatters'

import {
  NAME,
  RIGHT_TYPE,
  DIGITAL_ALLOCATION_TYPE,
  ALLOCATION,
  ALLOCATION_UNIT,
  DELIVERED,
  ACTION,
  RIGHT_TYPE_OTHER,
  BUDGET,
  DIGITAL_ALLOCATION_IMPRESSIONS,
  BID_CAP,
  BRAND_KEYWORDS,
  REQUEST_CREATIVE_ASSETS,
  REQUEST_LOGO,
  CREATIVE_ASSETS_DATE,
  LOGO_DATE,
  CAMPAIGNS,
  SOCIAL_MEDIA_POST,
  LINKED_INSTAGRAM_ACCOUNT,
  INCLUDE_LINKED_INSTAGRAM_ACCOUNT
} from '../../fields'
import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

export const getInitialValues = ({ editedRight = {}, allocationUnits }) => {
  const rightAllocation = transformRightAllocationUnit(editedRight, allocationUnits)

  const instagramAccount = editedRight.instagram_accounts?.[0]

  return {
    [NAME]: editedRight[NAME] || '',
    [START_DATE]: clearTimeZone(editedRight[START_DATE]) || '',
    [END_DATE]: clearTimeZone(editedRight[END_DATE]) || '',
    [ALLOCATION]: editedRight[ALLOCATION] || '',
    [ALLOCATION_UNIT]: rightAllocation || '',
    [DELIVERED]: editedRight[DELIVERED] || '',
    [ACTION]: editedRight[ACTION] || '',
    [RIGHT_TYPE]: editedRight[RIGHT_TYPE] || RIGHT_TYPE_OTHER,
    [BUDGET]: editedRight[BUDGET] || '',
    [DIGITAL_ALLOCATION_TYPE]: editedRight['allocation_type'],
    [DIGITAL_ALLOCATION_IMPRESSIONS]: editedRight[ALLOCATION] || '',
    [BID_CAP]: editedRight[BID_CAP] || '',
    [BRAND_KEYWORDS]: editedRight[BRAND_KEYWORDS]?.length
      ? editedRight[BRAND_KEYWORDS].map(item => ({
          text: item,
          id: uuidv4()
        }))
      : [{ text: '', id: uuidv4() }],
    [REQUEST_CREATIVE_ASSETS]: editedRight[REQUEST_CREATIVE_ASSETS] || false,
    [CREATIVE_ASSETS_DATE]: editedRight[CREATIVE_ASSETS_DATE] || '',
    [REQUEST_LOGO]: editedRight[REQUEST_LOGO] || false,
    [LOGO_DATE]: editedRight[LOGO_DATE] || false,
    [CAMPAIGNS]: editedRight[CAMPAIGNS]?.length
      ? editedRight[CAMPAIGNS].map(item => ({
          ...item,
          text: item.external_id,
          provider: item.provider,
          id: uuidv4()
        }))
      : [{ text: '', id: uuidv4() }],
    [SOCIAL_MEDIA_POST]: editedRight.pages.length ? editedRight.pages[0].page_id : '',
    [INCLUDE_LINKED_INSTAGRAM_ACCOUNT]: !!instagramAccount,
    [LINKED_INSTAGRAM_ACCOUNT]: instagramAccount || ''
  }
}
